import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { v2 } from '@lendica/api';
import { Wallet } from '@lendica/wallet';
import { LayoutPlaceholder } from '@lendica/components';

export function RedirectLegacy({ to }: { to: string }) {
    const navigate = useNavigate();
    const location = useLocation();
    const isWallet = to === 'wallet';

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const memberships = (await v2.listMemberships()) as Array<{
                    company: string;
                    slug?: string;
                }>;
                if (cancelled) return;
                const first = memberships[0] || { company: 'demo', slug: 'demo' };
                const key = first.slug ?? first.company;
                navigate(`/c/${key}/${to}${location.search}`, { replace: true });
            } catch (_) {
                // noop
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [navigate, to, location]);

    return null;
}
